
// =======================
// Swiper Product Card Init
// =======================

function initProductCardSliders() {
  document.querySelectorAll(".product-card__media.swiper-container").forEach(function (el) {
    // Prevent double initialization
    if (!el.classList.contains("swiper-initialized")) {
      new Swiper(el, {
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: el.querySelector(".swiper-pagination"),
          dynamicBullets: true,
        },
        navigation: {
          nextEl: el.querySelector(".swiper-button-next"),
          prevEl: el.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          // Mobile < 768px → show pagination, hide arrows
          0: {
            navigation: { enabled: false },
            pagination: { enabled: true },
          },
          // Desktop ≥ 768px → show arrows, hide pagination
          768: {
            navigation: { enabled: true },
            pagination: { enabled: false },
          },
        },
      });
    }
  });
}

// =======================
// Retry initializer (for delayed content)
// =======================
let swiperInitAttempts = 0;
function retrySwiperInit() {
  initProductCardSliders();
  // Retry up to 5 times if not all sliders initialized
  if (
    document.querySelectorAll(".product-card__media.swiper-container:not(.swiper-initialized)").length &&
    swiperInitAttempts < 5
  ) {
    swiperInitAttempts++;
    setTimeout(retrySwiperInit, 500);
  }
}

// =======================
// Event Bindings
// =======================

// Run after DOM is ready
document.addEventListener("DOMContentLoaded", retrySwiperInit);

// Run again after full page load (fallback)
window.addEventListener("load", retrySwiperInit);

// Run when Shopify sections are reloaded (theme editor, AJAX reloads, etc.)
document.addEventListener("shopify:section:load", initProductCardSliders);
document.addEventListener("shopify:section:select", initProductCardSliders);

// (Optional) If your theme loads products via AJAX (infinite scroll, quick view, cart drawer)
// Hook into those custom events too:
document.addEventListener("ajaxProductLoad", initProductCardSliders);
document.addEventListener("quickViewOpen", initProductCardSliders);




// setTimeout(() => {
//   document.querySelectorAll(".product-card__media.swiper-container").forEach(function (el) {
//     new Swiper(el, {
//       loop: true,
//       slidesPerView: 1,
//       pagination: {
//         el: el.querySelector(".swiper-pagination"),
//         // clickable: true, 
//         dynamicBullets: true,
//       },
//       navigation: {
//         nextEl: el.querySelector(".swiper-button-next"),
//         prevEl: el.querySelector(".swiper-button-prev"),
//       },
//       breakpoints: {
//         // Mobile < 768px → hide arrows
//         0: {
//           navigation: {
//             enabled: false,
//           },
//           pagination: { 
//             enabled: true, 
//           },
//         },
//         // Desktop ≥ 768px → hide pagination
//         768: {
//           navigation: {
//             enabled: true,
//           },
//           pagination: { 
//             enabled: false, 
//           },
//         },
//       },
//     });
//   });
// }, 1000);

// function initProductCardSliders() {
//   document.querySelectorAll(".product-card__media.swiper-container").forEach(function (el) {
//     if (!el.swiper) { // prevent double init
//       new Swiper(el, {
//         loop: true,
//         slidesPerView: 1,
//         pagination: {
//           el: el.querySelector(".swiper-pagination"),
//           dynamicBullets: true,
//         },
//         navigation: {
//           nextEl: el.querySelector(".swiper-button-next"),
//           prevEl: el.querySelector(".swiper-button-prev"),
//         },
//         breakpoints: {
//           0: {
//             navigation: { enabled: false },
//             pagination: { enabled: true },
//           },
//           768: {
//             navigation: { enabled: true },
//             pagination: { enabled: false },
//           },
//         },
//       });
//     }
//   });
// }

// // Run once DOM is ready, then retry a few times
// let attempts = 0;
// function retrySwiperInit() {
//   initProductCardSliders();
//   if (document.querySelectorAll(".product-card__media.swiper-container:not(.swiper-initialized)").length && attempts < 5) {
//     attempts++;
//     setTimeout(retrySwiperInit, 500);
//   }
// }
// document.addEventListener("DOMContentLoaded", retrySwiperInit);
